<template>
  <div>
    <div class="wp">
      <div class="header">
        <div class="header_left">
          <span>良渚古城遗址景区</span>
          <span>世界文化遗产</span>
          <span>4.9</span>
          分
        </div>
        <div class="header_right">
          <div class="header_right_item">
            <div>
              <img src="https://smsycs.hxxpl.com.cn/2020/202007151029490627590.png" alt />
              <span>多云转阴</span>
            </div>
            <div>14℃~24℃</div>
          </div>
          <div class="header_right_item">
            <div>
              <span>空气质量</span>
            </div>
            <div>良</div>
          </div>
          <div class="header_right_item">
            <div>
              <span>空气湿度</span>
            </div>
            <div>51%</div>
          </div>
          <div class="header_right_item">
            <div>
              <span>风力等级</span>
            </div>
            <div>2</div>
          </div>
          <div class="header_right_item">
            <div>
              <span>PM2.5</span>
            </div>
            <div>2μg/m³</div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="content_top">
          <div class="current_tourists">
            <div>当前游客：</div>
            <div class="current_tourists_num">
              <div class="current_tourists_num_left">
                <span>4</span>
                <span>5</span>
                <span>6</span>
                <span>7</span>
                <span>8</span>
                人次
              </div>
              <div class="current_tourists_num_right">
                <span>
                  <p>入园累计</p>
                  <p>152668人次</p>
                </span>
                <span>
                  <p>出园累计</p>
                  <p>1867968人次</p>
                </span>
              </div>
            </div>
            <div class="current_tourists_info">
              <img src="https://smsycs.hxxpl.com.cn/2020/202007151132092815372.png " alt />
              <div class="current_tourists_info_right">
                <div>
                  <span>门票价格：</span>
                  <span class="text1">50</span>
                  <span>元</span>
                </div>
                <div>
                  <span>开放时间：</span>
                  <span>周一至周五 12:30-15:00</span>
                  <br />
                  <span class="text2">周六至周日 10:30-15:00</span>
                </div>
                <div>
                  <span>官方网址：</span>
                  <span>暂无</span>
                </div>
                <div>
                  <span>咨询电话：</span>
                  <span>13858095082</span>
                </div>
                <div>
                  <span>投诉电话：</span>
                  <span>13858095082</span>
                </div>
                <div>
                  <span>日承载量：</span>
                  <span>1000</span>
                </div>
              </div>
            </div>
          </div>
          <div class="proportion_tourists">
            <div class="proportion_tourists_title">
              <span>游客比例分析</span>
              <el-date-picker
                class="sup-time-choose"
                v-model="time"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </div>
            <div id="proportion_tourists_echart"></div>
          </div>
          <div class="search_internet">
            <div class="search_internet_title">网络热搜词</div>
            <div class="search_internet_text">
              <span>人气旺</span>
              <span>价格实惠</span>
              <span>中华五千年</span>
              <span>交通便利</span>
              <span>停车方便</span>
              <span>地方赞</span>
              <span>服务好</span>
              <span>人气旺</span>
            </div>
          </div>
        </div>
        <div class="content_bottom">
          <div class="content_bottom_item">
            <div class="proportion_tourists_title">
              <span>客源地排名</span>
              <el-date-picker
                class="sup-time-choose"
                v-model="time"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </div>
            <div id="tourist_analysis_echart"></div>
          </div>
          <div class="content_bottom_item">
            <div class="proportion_tourists_title">
              <span>游客停留时长</span>
              <el-date-picker
                class="sup-time-choose"
                v-model="time"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </div>
            <div id="tourist_stay_echart"></div>
          </div>
          <div class="content_bottom_item">
            <div class="proportion_tourists_title">
              <span>分时预约比例</span>
              <el-date-picker
                class="sup-time-choose"
                v-model="time"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </div>
            <div id="timeshare_ratio_echart"></div>
            <div class="tranvel_label_wp">
              <span v-for="(item,index) in travel" :key="index">
                <i :style="item.color"></i>
                {{item.text}}
              </span>
            </div>
          </div>
          <div class="content_bottom_item">
            <div class="internet_comment">
              <span>网络评价</span>
              <span>
                共
                <span class="text3">3000条</span>
                评论
              </span>
            </div>
            <div class="comment_label">
              <div class="comment_label1">
                <span>好评:</span>
                <span>80%</span>
              </div>
              <div class="comment_label2">
                <span>中评:</span>
                <span>15%</span>
              </div>
              <div class="comment_label3">
                <span>差评:</span>
                <span>5%</span>
              </div>
            </div>
            <div class="comment_content_wp">
              <div class="comment_content" v-for="(item,index) in comment" :key="index">
                <div class="comment_time">{{item.time}}</div>
                <div class="comment_text">{{item.content}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import echarts from 'echarts'
export default {
  props: [],
  data() {
    return {
      time: '',
      comment: [
        {
          time: '2020-07-01',
          content: '景点的门票价格实惠，不错的体验。'
        },
        {
          time: '2020-07-02',
          content: '景区车位充足，自驾特别方便。'
        },
        {
          time: '2020-07-03',
          content: '景区生态环境优美，各种鸟类在这出没，花草..'
        },
        {
          time: '2020-07-04',
          content: '希望周边的设施可以更加齐备'
        },
        {
          time: '2020-07-05',
          content: '风景非常好，值得一去，瞻仰千年文明。'
        }
      ],
      travel: [
        {
          color: { backgroundColor: '#6E65EF' },
          text: '预约已出行',
          pre: '40%'
        },
        {
          color: { backgroundColor: '#FFB833' },
          text: '预约中',
          pre: '35%'
        },
        {
          color: { backgroundColor: '#6EB2ED' },
          text: '预约爽约',
          pre: '25%'
        }
      ]
    }
  },
  created() {},
  methods: {
    proportionTourists() {
      var colorList = ['#776EEA', '#F55A53', '#FFB631', '#63C2E9']
      let option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        series: [
          {
            name: '',
            type: 'pie',
            selectedMode: 'single',
            radius: [0, '30%'],

            label: {
              position: 'inner',
              fontSize: 19
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: 30,
                name: '女',
                itemStyle: {
                  color: '#D49384'
                }
              },
              {
                value: 70,
                name: '男',
                itemStyle: {
                  color: '#84D4C0'
                }
              }
            ]
          },
          {
            name: '',
            type: 'pie',
            radius: ['40%', '60%%'],
            label: {
              formatter: '{b} \n{c}%',
              fontSize: 13,
              align: 'center'
            },
            labelLine: {
              length: 5,
              length2: 10,
              smooth: true
            },
            data: [
              {
                value: 40,
                name: '26-35岁',
                itemStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: '#6055F8' // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: '#776FEA' // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                label: {
                  formatter: '{b} \n{c}%',
                  fontSize: 13,
                  align: 'center',
                  color: colorList[0]
                }
              },
              {
                value: 15,
                name: '16-25岁',
                itemStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: '#F87456' // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: '#F45252' // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                label: {
                  formatter: '{b} \n{c}%',
                  fontSize: 13,
                  align: 'center',
                  color: colorList[1]
                }
              },
              {
                value: 15,
                name: '36-45岁',
                itemStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: '#FFC74B' // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: '#FFB128' // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                label: {
                  formatter: '{b} \n{c}%',
                  fontSize: 13,
                  align: 'center',
                  color: colorList[2]
                }
              },
              {
                value: 20,
                name: '45岁以上',
                itemStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: '#5ECBE7' // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: '#71ABEE' // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                label: {
                  formatter: '{b} \n{c}%',
                  fontSize: 13,
                  align: 'center',
                  color: colorList[3]
                }
              }
            ]
          }
        ]
      }
      var myChart = echarts.init(
        document.getElementById('proportion_tourists_echart')
      )
      myChart.setOption(option)
    },
    touristAnalysis() {
      var colorList = ['#DA5D7E', '#F18B55', '#F5AE50', '#4486C5', '#5AACEA']
      var index = 0
      let options = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              shadowBlur: 20,
              opacity: 0.6
            }
          }
        },
        legend: {
          show: false
        },
        grid: {
          top: 10,
          right: '23%',
          left: 100
        },
        barMaxWidth: '26',
        xAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          type: 'category',
          inverse: true,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisPointer: {
            label: {
              show: true,
              margin: 20
            }
          },
          data: [
            '浙江省',
            '江西省',
            '海南省',
            '江苏省',
            '湖北省',
            '湖南省',
            '河北省',
            '四川省',
            '贵州省'
          ],
          axisLabel: {
            margin: 90,
            fontSize: 14,
            align: 'left',
            color: '#5AACEA',
            lineHeight: 20,
            rich: {
              a1: {
                color: '#fff',
                backgroundColor: colorList[0],
                width: 18,
                height: 18,
                align: 'center'
              },
              a2: {
                color: '#fff',
                backgroundColor: colorList[1],
                width: 18,
                height: 18,
                align: 'center'
              },
              a3: {
                color: '#fff',
                backgroundColor: colorList[2],
                width: 18,
                height: 18,
                align: 'center'
              },
              b: {
                color: '#fff',
                backgroundColor: colorList[3],
                width: 18,
                height: 18,
                align: 'center'
              }
            },
            formatter: function(params) {
              if (index == 9) {
                index = 0
              }
              index++
              if (index - 1 < 3) {
                return ['{a' + index + '|' + index + '}' + '  ' + params].join(
                  '\n'
                )
              } else {
                return ['{b|' + index + '}' + '  ' + params].join('\n')
              }
            }
          }
        },
        series: [
          {
            z: 2,
            name: '人数',
            type: 'bar',
            data: [17956, 3952, 759, 0, 0, 0, 0, 0, 0].map((item, i) => {
              let itemStyle = {
                color: i > 3 ? colorList[3] : colorList[i]
              }
              return {
                value: item,
                itemStyle: itemStyle
              }
            }),
            label: {
              show: true,
              position: 'right',
              color: '#C6C6C6',
              fontSize: 14,
              offset: [0, 0]
            }
          }
        ]
      }
      var myChart = echarts.init(
        document.getElementById('tourist_analysis_echart')
      )
      myChart.setOption(options)
    },
    touristStay() {
      let options = {
        grid: {
          left: '12%',
          top: '15%',
          bottom: '12%',
          right: '8%'
        },
        xAxis: {
          data: ['2', '4', '6', '8'],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#4DB0F4',
              width: 1 //这里是为了突出显示加上的
            }
          },
          axisLabel: {
            textStyle: {
              color: '#4DB0F4',
              fontSize: 16
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            interval: 10,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#4DB0F4',
                width: 1 //这里是为了突出显示加上的
              }
            },
            axisLabel: {
              textStyle: {
                color: '#4DB0F4',
                fontSize: 14
              }
            },
            splitArea: {
              areaStyle: {
                color: 'rgba(255,255,255,.5)'
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#4DB0F4',
                width: 0.5,
                type: 'solid'
              }
            }
          }
        ],
        series: [
          {
            name: '时间',
            type: 'pictorialBar',
            barCategoryGap: '0%',
            symbol:
              'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
            label: {
              show: true,
              position: 'top',
              distance: 15,
              color: '#62B9A1',
              fontWeight: 'bolder',
              fontSize: 14,
              formatter: '{c}%'
            },
            itemStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#62B9A1' //  0%  处的颜色
                    },
                    {
                      offset: 1,
                      color: '#62B9A1' //  100%  处的颜色
                    }
                  ],
                  global: false //  缺省为  false
                }
              },
              emphasis: {
                opacity: 1
              }
            },
            data: [80, 60, 49, 30],
            z: 10
          }
        ]
      }
      var myChart = echarts.init(document.getElementById('tourist_stay_echart'))
      myChart.setOption(options)
    },
    timeshareRatio() {
      let options = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}%'
        },
        series: [
          {
            name: '预约比例',
            type: 'pie',
            radius: [0, 90],
            center: ['40%', '80%'],
            roseType: 'radius',
            left: 35,
            top: -400,
            label: {
              position: 'outer',
              fontSize: '16',
              formatter: '{c}%'
            },
            labelLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)'
              },
              length: 10,
              length2: 0
            },
            data: [
              {
                value: 40,
                name: '预约已出行',
                itemStyle: {
                  color: '#6E65EF'
                }
              },
              {
                value: 35,
                name: '预约爽约',
                itemStyle: {
                  color: '#FFB833'
                }
              },
              {
                value: 25,
                name: '预约中',
                itemStyle: {
                  color: '#6EB2ED'
                }
              }
            ]
          }
        ]
      }
      var myChart = echarts.init(
        document.getElementById('timeshare_ratio_echart')
      )
      myChart.setOption(options)
    }
  },
  mounted() {
    // 游客比例分析
    this.proportionTourists()
    //  客源地排名
    this.touristAnalysis()
    // 游客停留时长
    this.touristStay()
    // 分时预约比例
    this.timeshareRatio()
  },
  components: {}
}
</script>

<style scoped>
.wp {
  width: 100%;
  height: 884px;
  padding: 14px 20px 0 10px;
  background: url('https://smsycs.hxxpl.com.cn/2020/202007150946037346482.png')
    no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  font-size: 16px;
  color: #f9f9f8;
}
.header {
  height: 100px;
  margin: 0 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #4db0f4;
}

.header_left {
  font-size: 16px;
  color: #fff;
}

.header_left span {
  font-size: 34px;
  margin-right: 15px;
}

.header_left span:nth-child(2) {
  color: #f6b544;
}
.header_left span:nth-child(3) {
  color: #f6b544;
  margin-right: 0;
}

.header_right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 18px;
  color: #fff;
}

.header_right img {
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 4px;
}

.header_right_item {
  width: 120px;
  text-align: center;
}

.header_right_item div:nth-child(1) {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
}
.header_right_item div:nth-child(2) {
  color: #f6b544;
  font-size: 16px;
}

.content {
  margin: 20px 20px 0;
}

.content_top {
  width: 100%;
  display: flex;
}

.current_tourists {
  width: 658px;
  height: 334px;
  background: url('https://smsycs.hxxpl.com.cn/2020/202007151051032034599.png')
    no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 8px 0 0 8px;
  color: #fff;
  font-size: 18px;
}

.current_tourists_num {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 4px;
}

.current_tourists_num_left {
  display: flex;
  align-items: flex-end;
  font-size: 16px;
}

.current_tourists_num_left span {
  width: 42px;
  height: 59px;
  font-size: 42px;
  text-align: center;
  line-height: 59px;
  color: #89eaff;
  font-weight: 700;
  background: rgba(0, 53, 178, 0.3);
  border: 2px solid;
  border-image: linear-gradient(
      0deg,
      rgba(36, 196, 255, 1),
      rgba(0, 87, 194, 1)
    )
    10 10;
  margin-right: 12px;
}

.current_tourists_num_left span:last-child {
  margin-right: 0;
}

.current_tourists_num_right {
  display: flex;
}

.current_tourists_num_right span {
  min-width: 90px;
  height: 72px;
  background: url('https://smsycs.hxxpl.com.cn/2020/202007151123167658773.png')
    no-repeat;
  background-size: 100% 100%;
  margin-left: 17px;
  font-size: 16px;
  text-align: center;
}

.current_tourists_num_right span p:nth-child(1) {
  height: 26px;
  line-height: 26px;
}
.current_tourists_num_right span p:nth-child(2) {
  font-size: 14px;
  color: #89eaff;
  margin-top: 15px;
  padding: 0 10px;
}

.current_tourists_info {
  display: flex;
  justify-content: start;
  align-items: flex-start;
  margin-top: 18px;
}

.current_tourists_info img {
  width: 302px;
  height: 189px;
}

.current_tourists_info_right {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  color: #f9f9f8;
  margin-left: 20px;
  line-height: 1.6;
  letter-spacing: 2px;
}

.text1 {
  color: #f6b544;
  font-size: 22px;
}

.text2 {
  margin-left: 97px;
}

.proportion_tourists {
  width: 321px;
  height: 334px;
  background: url('https://smsycs.hxxpl.com.cn/2020/202007151321329846490.png')
    no-repeat;
  background-size: 100% 100%;
  margin-left: 8px;
  padding: 8px 0 0 8px;
  box-sizing: border-box;
}

.proportion_tourists_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#proportion_tourists_echart {
  width: 100%;
  height: 300px;
}

.sup-time-choose {
  width: 192px;
  height: 28px;
  background-color: transparent;
  border: 1px solid #4db0f4;
  border-radius: 14px;
  padding: 0;
  margin-right: 8px;
}

.sup-time-choose >>> .el-range__icon {
  font-size: 14px;
  color: #c0c4cc;
  float: right;
  line-height: 28px;
  margin-left: 8px;
}

.sup-time-choose >>> .el-range-separator {
  color: #9fbfe0;
  line-height: 26px;
}

.sup-time-choose >>> .el-range-input {
  background-color: transparent;
  color: #9fbfe0;
  font-size: 12px;
}

.sup-time-choose >>> .el-range__close-icon {
  line-height: 28px;
}

.search_internet {
  width: 276px;
  height: 334px;
  background: url('https://smsycs.hxxpl.com.cn/2020/202007151337062190160.png')
    no-repeat;
  background-size: 100% 100%;
  margin-left: 8px;
  padding: 8px 0 0 8px;
  box-sizing: border-box;
}

.search_internet_text {
  position: relative;
}

.search_internet_text span {
  position: absolute;
}

.search_internet_text span:nth-child(1) {
  font-size: 16px;
  color: #8e63bd;
  top: 47px;
  left: 55px;
}
.search_internet_text span:nth-child(2) {
  font-size: 16px;
  color: #c3472e;
  top: 35px;
  right: 35px;
}
.search_internet_text span:nth-child(3) {
  font-size: 20px;
  color: #776eea;
  top: 83px;
  left: 20px;
}
.search_internet_text span:nth-child(4) {
  font-size: 22px;
  color: #eace6e;
  top: 102px;
  right: 20px;
}
.search_internet_text span:nth-child(5) {
  font-size: 26px;
  color: #84d4c0;
  top: 144px;
  left: 20px;
}
.search_internet_text span:nth-child(6) {
  font-size: 20px;
  color: #8fbcfa;
  top: 176px;
  right: 50px;
}
.search_internet_text span:nth-child(7) {
  font-size: 20px;
  color: #776eea;
  top: 215px;
  left: 50px;
}
.search_internet_text span:nth-child(8) {
  font-size: 16px;
  color: #8e63bd;
  top: 248px;
  right: 40px;
}

.content_bottom {
  display: flex;
  justify-content: start;
  align-items: flex-start;
  margin-top: 8px;
}

.content_bottom_item {
  width: 312px;
  height: 382px;
  background: url('https://smsycs.hxxpl.com.cn/2020/202007151344573754521.png')
    no-repeat;
  background-size: 100% 100%;
  padding: 8px 0 0 8px;
  box-sizing: border-box;
  margin-right: 5px;
  overflow: hidden;
}

.content_bottom_item:last-child {
  margin-right: 0;
}

.internet_comment {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 20px;
}

.text3 {
  color: #89eaff;
}

.comment_label {
  width: 100%;
  padding-right: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
}

.comment_label1 {
  color: #89eaff;
}
.comment_label2 {
  color: #ffc140;
}
.comment_label3 {
  color: #f66454;
}

.comment_content_wp {
  margin-top: 15px;
  padding: 0 8px 0 0;
  box-sizing: border-box;
}

.comment_content {
  font-size: 12px;
  color: #e3e3e3;
  border: 1px solid rgba(35, 50, 111, 1);
  border-top: 0;
}

.comment_time {
  color: #89eaff;
  height: 19px;
  line-height: 19px;
  background-color: #2c3c7c;
  padding-left: 8px;
}

.comment_text {
  padding-left: 8px;
  min-height: 33px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

#tourist_analysis_echart {
  width: 100%;
  height: 400px;
}

#tourist_stay_echart {
  width: 100%;
  height: 340px;
}
#timeshare_ratio_echart {
  width: 100%;
  height: 260px;
  margin-top: 20px;
}

.tranvel_label_wp {
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 16px;
  color: #c9dffb;
  margin-left: -10px;
  margin-top: 10px;
  width: 100%;
}

.tranvel_label_wp i {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/assets/scenicDetails/scenicDetail.vue